<template>
    <div class="my-2 my-lg-0 d-flex align-items-center w-100 w-md-auto">
        <input
            class="form-control mr-2"
            type="search"
            :placeholder="placeholder"
            aria-label="Search"
            v-model="term"
        />

        <slot name="searchButton">
            <button
                class="btn btn-primary my-2 my-sm-0"
                v-on:click="$emit('search', term)"
                type="button"
                :disabled="loading"
            >
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="loading" />
                <span v-if="loading">Loading...</span>
                <span v-else> Search</span>
            </button>
        </slot>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            value: String,
            placeholder: String,
            loading: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                term: this.value
            };
        },
        watch: {
            term() {
                this.$emit('input', this.term);
            }
        }
    });
</script>
